import { request } from '../auth/client';
import type {
  AdminCreateInput,
  AdminListQuery,
  AdminRow,
  AdminUpdateInput,
  PaginatedResponse,
} from '@runik/shared';

export const adminsKey = (query?: Partial<AdminListQuery>) =>
  ['admins', { ...(query ?? {}) }] as const;

export function listAdmins(query: Partial<AdminListQuery>) {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.limit) params.set('limit', String(query.limit));
  return request<PaginatedResponse<AdminRow>>(`/api/admins?${params.toString()}`);
}

export function createAdmin(body: AdminCreateInput) {
  return request<{ id: string; email: string }>('/api/admins', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateAdmin(id: string, body: AdminUpdateInput) {
  return request<{ id: string }>(`/api/admins/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function deleteAdmin(id: string) {
  return request<void>(`/api/admins/${id}`, { method: 'DELETE' });
}
